export const LOCAL = {
  API_URL: 'https://localhost:5001/sfs/',
  RAPID_URL: "https://dev.api.platts.com/",
  clientId: '******',
  issuer: 'https://secure.signinpreview.spglobal.com/oauth2/spglobal',
};

export const DEV = {
  API_URL: 'https://dev.api.platts.com/sfs/',
  RAPID_URL: "https://dev.api.platts.com/",
  clientId: '******',
  issuer: 'https://secure.signinpreview.spglobal.com/oauth2/spglobal',
};

export const QA = {
  API_URL: 'https://qa-us.api.platts.com/sfs/',
  RAPID_URL: "https://dev.api.platts.com/",
  clientId: '******',
  issuer: 'https://secure.signinpreview.spglobal.com/oauth2/spglobal',
};

export const QAEU = {
  API_URL: 'https://qa-eu.api.platts.com/sfs/',
  RAPID_URL: "https://qa.api.platts.com/",
  clientId: '******',
  issuer: 'https://secure.signinpreview.spglobal.com/oauth2/spglobal',
};

export const PROD = {
  API_URL: 'https://api.platts.com/sfs/',
  RAPID_URL: "https://prod.api.platts.com/",
  clientId: '******',
  issuer: 'https://secure.signin.spglobal.com/oauth2/spglobal',
};

export const PRODEU = {
  API_URL: 'https://api.platts.com/sfs/',
  RAPID_URL: "https://prod.api.platts.com/",
  clientId: '******',
  issuer: 'https://secure.signin.spglobal.com/oauth2/spglobal',
};
